// extracted by mini-css-extract-plugin
var _1 = "GroupCard-module__animateUploadProgressBarWidth--wulj8";
var _2 = "GroupCard-module__animatedBackground--rkmxj";
var _3 = "GroupCard-module__cardContainer--PPxXX";
var _4 = "GroupCard-module__description--ASIIC";
var _5 = "GroupCard-module__innerContainer--ncuI7";
var _6 = "GroupCard-module__title--W2wfs";
var _7 = "GroupCard-module__users--WaAcL";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "cardContainer", _4 as "description", _5 as "innerContainer", _6 as "title", _7 as "users" }
